import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useState, useEffect, useCallback } from "react";

import Svg from "../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../ui library/HNSColors";
import STRINGS from "../../utils/strings";

export default function SearchBar({ searchText, setSearchText, resetCurrentPage }) {
  const [localSearch, setLocalSearch] = useState(searchText);

  useEffect(() => {
    setLocalSearch(searchText);
  }, [searchText]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchText(localSearch);
    }, 700);

    return () => clearTimeout(handler);
  }, [localSearch, setSearchText]);

  const onValueChange = (event) => {
    setLocalSearch(event.target.value);
    resetCurrentPage();
  };

  const clear = useCallback(() => {
    setLocalSearch("");
  }, []);

  return (
    <div
      className="m-0 inline-flex w-full flex-row content-center items-center rounded-[500px] border-[1px] p-0"
      style={{ borderColor: HNSColors.secondary[800] }}
    >
      <div className="ml-4 mr-0">
        <Svg name="his-magnifying-glass" color={HNSColors.neutrals[600]} sx={{ height: "20px" }} />
      </div>
      <div className="h-full flex-1">
        <TextField
          id="search-bar"
          label={STRINGS.SEARCH_SERVICES_PLACEHOLDER}
          className="w-full"
          variant="outlined"
          value={localSearch}
          onChange={(e) => onValueChange(e)}
          slotProps={{ inputLabel: { shrink: true } }}
          sx={{
            padding: "0",
            "& .MuiOutlinedInput-root": {
              "& fieldset": { border: "none" },
              "&:hover fieldset": { border: "none" },
              "& .Mui-focused fieldset": { border: "none" },
            },
            "& .MuiInputLabel-shrink": { display: "none" },
            "& .MuiInputBase-input.MuiOutlinedInput-input": {
              padding: "10px 12px",
              fontSize: "14px",
            },
            "& .MuiFormLabel-root": {
              fontSize: "14px",
              position: "absolute",
              top: "-5px",
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {searchText && (
                  <IconButton
                    onClick={clear}
                    size="small"
                    sx={{
                      position: "absolute",
                      right: 8,
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  >
                    <Svg
                      name="his-x"
                      color={HNSColors.neutrals[600]}
                      sx={{ width: 16, height: 16 }}
                    />
                  </IconButton>
                )}
              </InputAdornment>
            ),
          }}
        />
      </div>
    </div>
  );
}
